export default "__VITE_ASSET__DIxOKIkQ__"